<div class="detail-page">
  <a class="detail-back" [routerLink]="['/recipient/list']">
    <app-detail-icon name="arrow-left" [size]="15"></app-detail-icon>
    Back to Recipients
  </a>

  <ng-container *ngIf="recipientData as recipient">
    <!-- Header: identity + actions -->
    <header class="detail-header">
      <div>
        <h1 class="detail-header__title">{{ fullName }}</h1>
        <div class="detail-header__meta">
          <span class="detail-mono">B{{ recipient.bene_id }}</span>
          <a *ngIf="recipient.bene_email" [href]="'mailto:' + recipient.bene_email">
            {{ recipient.bene_email }}
          </a>
        </div>
      </div>

      <div class="detail-header__actions">
        <button
          type="button"
          class="detail-btn detail-btn--accent"
          *appHasAccess="'/recipient/edit/:id'"
          [routerLink]="['/recipient/edit', recipient.bene_id]">
          <app-detail-icon name="pencil" [size]="14"></app-detail-icon>
          Edit
        </button>
      </div>
    </header>

    <div class="detail-stack">
      <div class="detail-grid">
        <!-- Recipient information -->
        <section class="detail-card">
          <div class="detail-card__head">
            <app-detail-icon
              class="detail-card__icon"
              name="user"
              [size]="18"></app-detail-icon>
            <h2 class="detail-card__title">Recipient Information</h2>
          </div>

          <div class="detail-kv">
            <span class="detail-kv__label">Status</span>
            <span class="detail-kv__value">
              <span
                class="detail-pill"
                [ngClass]="recipient.is_active | statusPill">
                {{ recipient.is_active ? 'Active' : 'Inactive' }}
              </span>
              <span
                class="detail-pill detail-pill--warn"
                *ngIf="recipient.is_favorite">
                Favorite
              </span>
              <span
                class="detail-pill detail-pill--danger"
                *ngIf="recipient.is_deleted">
                Deleted
              </span>
            </span>
          </div>
          <div class="detail-kv">
            <span class="detail-kv__label">AML Status</span>
            <span class="detail-kv__value">
              <span
                class="detail-pill"
                [ngClass]="recipient.aml_status | statusPill">
                {{ recipient.aml_status || 'Not set' }}
              </span>
            </span>
          </div>
          <div class="detail-kv">
            <span class="detail-kv__label">Recipient ID</span>
            <span class="detail-kv__value detail-mono">
              {{ recipient.bene_id }}
            </span>
          </div>
          <div class="detail-kv">
            <span class="detail-kv__label">Sender</span>
            <span class="detail-kv__value">
              <a
                [routerLink]="[
                  '/sender/details',
                  isSuperAdmin
                    ? recipient.sender_id + '-' + recipient.partner_id
                    : recipient.sender_id,
                ]">
                #{{ recipient.sender_id }}
              </a>
            </span>
          </div>
          <div class="detail-kv">
            <span class="detail-kv__label">Beneficiary Country</span>
            <span class="detail-kv__value">
              <img
                [src]="
                  'assets/images/country-square/' +
                  recipient.benificiary_country +
                  '.png'
                "
                alt=""
                class="detail-flag me-1"
                onerror="this.style.display='none'" />
              {{ recipient.benificiary_country }}
            </span>
          </div>

          <div class="detail-iconrow" *ngIf="recipient.bene_email">
            <app-detail-icon
              class="detail-iconrow__icon"
              name="mail"
              [size]="16"></app-detail-icon>
            <span class="detail-iconrow__value">
              <a [href]="'mailto:' + recipient.bene_email">
                {{ recipient.bene_email }}
              </a>
            </span>
          </div>
          <div class="detail-iconrow">
            <app-detail-icon
              class="detail-iconrow__icon"
              name="phone"
              [size]="16"></app-detail-icon>
            <span class="detail-iconrow__value">
              <a
                [href]="
                  'tel:' +
                  recipient.bene_mobile_code +
                  recipient.bene_mobile_number
                ">
                {{ recipient.bene_mobile_code }}
                {{ recipient.bene_mobile_number }}
              </a>
            </span>
          </div>
          <div class="detail-iconrow" *ngIf="recipient.created_at">
            <app-detail-icon
              class="detail-iconrow__icon"
              name="calendar"
              [size]="16"></app-detail-icon>
            <span>
              <span class="detail-iconrow__label d-block">Added On</span>
              <span class="detail-iconrow__value">
                {{ recipient.created_at | date: 'MMM d y, hh:mm a' }}
              </span>
            </span>
          </div>

          <div class="detail-section">
            <div class="detail-section__title">Profile</div>
            <div class="detail-kv">
              <span class="detail-kv__label">Full Name</span>
              <span class="detail-kv__value">{{ fullName }}</span>
            </div>
            <div class="detail-kv">
              <span class="detail-kv__label">Gender</span>
              <span class="detail-kv__value">{{ genderLabel }}</span>
            </div>
            <div class="detail-kv">
              <span class="detail-kv__label">Date of Birth</span>
              <span class="detail-kv__value">
                {{ recipient.bene_date_of_birth || '—' }}
              </span>
            </div>
            <div class="detail-kv">
              <span class="detail-kv__label">Relationship to Sender</span>
              <span class="detail-kv__value">
                {{ recipient.sender_beneficiary_relation || '—' }}
              </span>
            </div>
          </div>

          <div class="detail-section">
            <div class="detail-section__title">Address</div>
            <div class="detail-kv">
              <span class="detail-kv__label">Address</span>
              <span class="detail-kv__value">
                {{ recipient.bene_address || '—' }}
              </span>
            </div>
            <div class="detail-kv">
              <span class="detail-kv__label">City</span>
              <span class="detail-kv__value">
                {{ recipient.bene_city || '—' }}
              </span>
            </div>
            <div class="detail-kv">
              <span class="detail-kv__label">Postal Code</span>
              <span class="detail-kv__value">
                {{ recipient.bene_post_code || '—' }}
              </span>
            </div>
            <div class="detail-kv">
              <span class="detail-kv__label">Country</span>
              <span class="detail-kv__value">
                <img
                  [src]="
                    'assets/images/country-square/' +
                    recipient.benificiary_country +
                    '.png'
                  "
                  alt=""
                  class="detail-flag me-1"
                  onerror="this.style.display='none'" />
                {{ recipient.benificiary_country }}
              </span>
            </div>
          </div>
        </section>

        <!-- Payout details -->
        <section class="detail-card">
          <div class="detail-card__head">
            <app-detail-icon
              class="detail-card__icon"
              name="arrow-left-right"
              [size]="18"></app-detail-icon>
            <h2 class="detail-card__title">Payout Details</h2>
          </div>

          <div class="detail-kv">
            <span class="detail-kv__label">Transfer Type</span>
            <span class="detail-kv__value">
              {{ recipient.transfer_type_po || '—' }}
            </span>
          </div>
          <div class="detail-kv">
            <span class="detail-kv__label">Purpose</span>
            <span class="detail-kv__value">{{ recipient.purpose || '—' }}</span>
          </div>
          <div class="detail-kv" *ngIf="recipient.bene_card_number">
            <span class="detail-kv__label">Card Number</span>
            <span class="detail-kv__value detail-mono">
              {{ recipient.bene_card_number }}
            </span>
          </div>

          <div class="detail-section">
            <div class="detail-section__title">Bank Details</div>
            <div class="detail-empty" *ngIf="!recipient.bene_bank_details">
              <app-detail-icon name="landmark" [size]="28"></app-detail-icon>
              <p>No bank details available</p>
            </div>
          </div>

          <div class="detail-section">
            <div class="detail-section__title">Record</div>
            <div class="detail-kv">
              <span class="detail-kv__label">Created By</span>
              <span class="detail-kv__value">
                {{ recipient.created_by || '—' }}
              </span>
            </div>
            <div class="detail-kv">
              <span class="detail-kv__label">Created Date</span>
              <span class="detail-kv__value">
                {{ recipient.created_at | date: 'MMM d y, hh:mm a' }}
              </span>
            </div>
            <div class="detail-kv">
              <span class="detail-kv__label">Last Updated</span>
              <span class="detail-kv__value">
                {{ recipient.updated_at | date: 'MMM d y, hh:mm a' }}
              </span>
            </div>
          </div>
        </section>
      </div>
    </div>
  </ng-container>
</div>
